import {useSelector} from 'react-redux'

/**
 * Custom React Hook to get random.org API response from state.
 * @see https://reactjs.org/docs/hooks-custom.html
 */
const useLanguagesAPI = () => useSelector(state => state.languages)
export default useLanguagesAPI


export const useAboutContentAPI = () => useSelector(state => state.aboutContent)
